export enum EmotionStatus {
  very_bad = 1,
  bad = 2,
  good = 3,
  very_good = 4,
  excellent = 5
}

export interface SurveyEmotionModel {
  titulo: string;
  status: keyof typeof EmotionStatus;
}

export interface SurveyTagModel {
  texto_tag: string;
}

export interface SurveyModel {
  titulo: string;
  slug: string;
  descricao: string;
  emocoes: SurveyEmotionModel[];
  tags: SurveyTagModel[];
  esta_ativa: boolean;
}
